// app-config.js — deploy-specific constants.
//
// PROD_BASE_URL: the public URL where the web app is deployed (Cloudflare Pages).
// The native Android app cannot use relative URLs for the /matches cloud-sync
// API (its origin is https://localhost), so it needs the absolute production
// URL here. Leave empty only if cloud resume should be disabled in the APK.
export const PROD_BASE_URL = "https://ffpl-scorer.pages.dev"; // e.g. "https://cricket-scorer.pages.dev" — SET BEFORE ANDROID RELEASE

// Temporary launch rollout: everyone receives PRO access without mutating
// Firestore subscription records. Set this single flag to false when paid
// entitlement enforcement is ready to resume.
export const TEMP_ALL_USERS_PRO = true;

// App version — injected from package.json at build time (see vite.config.js).
// Used by the force-update check against Firestore config/appSettings.
export const APP_VERSION = typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : '0.0.0';

// Numeric version for minRequiredVersion comparisons (major*10000+minor*100+patch).
export function versionToNumber(v) {
  const [maj = 0, min = 0, pat = 0] = String(v).split('.').map(n => parseInt(n, 10) || 0);
  return maj * 10000 + min * 100 + pat;
}
export const APP_VERSION_CODE = versionToNumber(APP_VERSION);

// Play Store listing URL — used by the force-update screen inside the APK.
export const PLAY_STORE_URL = "market://details?id=com.ffpl.cricketscorer";
